//  Dependencies

import React, { Component} from 'react';
import FacebookProvider, { Page } from 'react-facebook';

// Components

import Header from '../Header/Header';

// Style

import './Facebook.css';

export default class Facebook extends Component {
    render() {
      return (
        <div className="face-book">
          <FacebookProvider appId="1494047150649560">
          <Page href="https://www.facebook.com/hibachiandyou" tabs="timeline" />
          </FacebookProvider>
        </div>
      );
    }
  }


// WEBPACK FOOTER //
// ./src/Facebook/Facebook.js